import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

// font awesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";

// components
import DashPagination from "./dashPagination";
import { showToast } from "../../store/slices/toastSlice";
import ConfirmPopup from "../common/confirmPopup";
import axiosInstance from "../../apis/config";
import Spinner from "../common/spinner";

// style
import dashStyle from "./../../pages/dashboard/dashboard.module.css";

const SubscribersDash = () => {
  const [allUsers, setAllUsers] = useState([]);
  const [allUsersInPage, setAllUsersInPage] = useState([]);
  const [totalUsers, setTotaUsers] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [userIdToDelete, setUserIdToDelete] = useState("");
  const [showWarning, setShowWarning] = useState(false);
  const [showSpinner, setShowSpinner] = useState(true);
  const token = localStorage.getItem("userToken");
  const dispatch = useDispatch();

  useEffect(() => {
    if (searchQuery === "") {
      // If search query is empty, show all users
      axiosInstance
        .get(`/subscribers`, {
          params: {
            page: currentPage,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            "x-access-token": token,
          },
        })
        .then((res) => {
          setAllUsersInPage(res.data);
          setAllUsers(res.data.data);
          setTotaUsers(res.data.totalUsers);
          setShowSpinner(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      axiosInstance
        .get(`/subscribers/search`, {
          params: {
            search: searchQuery,
            page: currentPage,
          },
        })
        .then((res) => {
          setAllUsersInPage(res.data);
          setAllUsers(res.data.data);
          setTotaUsers(res.data.totalUsers);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // eslint-disable-next-line
  }, [currentPage, searchQuery]);

  // delete user
  function deleteUser(phoneNumber) {
    setShowWarning(false);

    console.log("phoneNumber", phoneNumber);

    axiosInstance
      .delete(`/subscribers`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-access-token": token,
        },
        data: {
          phoneNumber: phoneNumber,
        },
      })
      .then((res) => {
        dispatch(showToast("Subscriber was deleted successfully!"));
        axiosInstance
          .get(`/subscribers`, {
            params: {
              page: currentPage,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              "x-access-token": token,
            },
          })
          .then((res) => {
            setAllUsersInPage(res.data);
            setAllUsers(res.data.data);
            setTotaUsers(res.data.totalUsers);
            setUserIdToDelete("");
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
        showToast("Failed to delete user! Please try again later!");
      });
  }

  // Update current page state when page number is clicked
  function onPageChange(page) {
    setCurrentPage(page);
  }

  // search for id or phone number
  function handleSearch(event) {
    const query = event.target.value.trim().toLowerCase();
    setCurrentPage(1);
    setSearchQuery(query);
    if (query === "") {
      // If search query is empty, show all users
      setAllUsersInPage(allUsers);
    } else {
      // If search query is not empty, fetch search results
      setAllUsersInPage(allUsers);
    }
  }

  return (
    <div className={`py-4`}>
      <h1 className={`mb-2 h4 py-3 ps-4 ${dashStyle["fw-bold"]}`}>
        Users (total: {totalUsers})
      </h1>

      <div className="overflow-x-auto">
        <div className="row ms-4 me-3">
          <div className="my-4 col-12 col-md-6 d-flex align-items-center justify-content-start ">
            <input
              className="form-control"
              type="search"
              placeholder="Search by user id or phone number"
              aria-controls="DataTables_Table_0"
              value={searchQuery}
              onChange={handleSearch}
            />
          </div>
        </div>
        {!showSpinner ? (
          <>
            <div className="table-responsive mb-5">
              <table className="table border-top" id="DataTables_Table_0">
                <thead>
                  <tr>
                    <th scope="col" className="ps-4">
                      #ID
                    </th>
                    <th scope="col">Subcribed On</th>
                    <th scope="col">Phone</th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {allUsers.length > 0 ? (
                    allUsers.map((user) => {
                      return (
                        <tr key={user._id}>
                          <th className={`ps-4 `} data-id={user._id}>
                            <span className={`d-block`}>{user._id}</span>
                          </th>
                          <td className="text-center">
                            {new Date(user.dateSubscribed).toLocaleDateString()}
                          </td>
                          <td
                            className={
                              user.phoneNumber !== ""
                                ? "text-start"
                                : "text-center"
                            }
                          >
                            {user.phoneNumber !== "" ? user.phoneNumber : "x"}
                          </td>
                          <td className="text-center">
                            <FontAwesomeIcon
                              icon={faTrashCan}
                              type="button"
                              onClick={() => {
                                setUserIdToDelete(user.phoneNumber);
                                setShowWarning(true);
                              }}
                              className="text-danger"
                            />
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No users found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <DashPagination
              totalPages={allUsersInPage.totalPages}
              currentPage={currentPage}
              onPageChange={onPageChange}
            />
          </>
        ) : (
          <Spinner />
        )}

        {showWarning && userIdToDelete && (
          <ConfirmPopup
            msg={"Are you sure you want to delete subscriber?"}
            onConfirm={() => deleteUser(userIdToDelete)}
            onCancel={() => {
              setShowWarning(false);
              setUserIdToDelete("");
            }}
          />
        )}
      </div>
    </div>
  );
};

export default SubscribersDash;
